export default value => !!value.match(/^[+38\s]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g);
